import axios from "axios";
import _get from "lodash/get";

import getErrorDetails from "../../../api/helpers/getErrorDetails";
import { authApi } from "../../../api/rtkApi";
import {
  GENERIC_ERROR,
  INVALID_CREDENTIALS,
  TOO_MANY_REQUESTS,
} from "../../../constants/errors";
import { axiosAuthInstance } from "./axiosAuthInstance";

const genericError = {
  name: GENERIC_ERROR,
  message: GENERIC_ERROR,
  code: GENERIC_ERROR,
} as Error;

export async function authenticate(
  { email, password }: { email: string; password: string },
  options: any
) {
  try {
    const response = await axiosAuthInstance({
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: "/oauth",
      data: {
        grant_type: "portal",
        username: email,
        password,
      },
    });

    const token = _get(response, "data.access_token");

    if (!token) {
      let error = {
        name: INVALID_CREDENTIALS,
        message: INVALID_CREDENTIALS,
        code: INVALID_CREDENTIALS,
      } as Error;
      throw error;
    }

    return response.data;
  } catch (error) {
    switch (error?.response?.status) {
      case 401: {
        let betterError = {
          name: INVALID_CREDENTIALS,
          message: INVALID_CREDENTIALS,
          code: INVALID_CREDENTIALS,
        } as Error;
        throw betterError;
      }
      case 429: {
        let betterError = {
          name: TOO_MANY_REQUESTS,
          message: TOO_MANY_REQUESTS,
          code: TOO_MANY_REQUESTS,
          time: error.response.headers["x-ratelimit-reset"] || false,
        } as Error;
        throw betterError;
      }
      default: {
        throw genericError;
      }
    }
  }
}

export async function refresh(
  { refreshToken }: { refreshToken: string },
  options: any
) {
  try {
    const response = await axios({
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: "/token/refresh",
      data: {
        refresh_token: refreshToken,
      },
    });

    const token = _get(response, "data.access_token");

    if (!token) {
      let error = {
        name: INVALID_CREDENTIALS,
        message: INVALID_CREDENTIALS,
        code: INVALID_CREDENTIALS,
      } as Error;
      throw error;
    }

    return response.data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export type PostInvalidateRefreshTokenMutation = {
  refreshToken: string;
};

const extendedApi = authApi.injectEndpoints({
  endpoints: (build) => ({
    invalidateRefreshToken: build.mutation<
      undefined,
      PostInvalidateRefreshTokenMutation
    >({
      query: ({ refreshToken: refresh_token }) => ({
        url: "/token/invalidate",
        method: "POST",
        body: {
          refresh_token,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
  overrideExisting: false,
});

export const { useInvalidateRefreshTokenMutation } = extendedApi;
